import React, { Component } from 'react';
import LanguageContext, { LanguageProvider } from '../../../utils/common/LanguageContext';

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

export class NoAppointmentsFound extends Component {
    render() {
        const { isText, translationKey, isFrom } = this.props;

        let displayText;
        if (isText) {
            // If isText is provided, check if it should be translated
            displayText = this.props.t ? this.props.t(isText) || isText : isText;
        } else if (translationKey) {
            // Use translation key directly
            displayText = this.props.t(translationKey);
        } else if (isFrom) {
            // Legacy support: construct "No {isFrom} Found." message
            // Map common isFrom values to translation keys
            const translationKeyMap = {
                Session: 'noSessionFound',
                'Team Members': 'noTeamMembersFound',
            };
            displayText = translationKeyMap[isFrom]
                ? this.props.t(translationKeyMap[isFrom])
                : `No ${isFrom} Found.`;
        } else {
            displayText = this.props.t('noDataFound');
        }

        return (
            <ul className="demo-list-three mdl-list">
                <li
                    className="mdl-list__item mdl-list__item--three-line"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignContent: 'center',
                    }}
                >
                    <div>
                        <span className="mdl-list__item-primary-content">
                            <span style={{ color: isText ? 'black' : 'white' }}>{displayText}</span>
                        </span>
                    </div>
                </li>
            </ul>
        );
    }
}

const ConnectedNoAppointmentsFound = withLanguage(NoAppointmentsFound);

export default (props) => (
    <LanguageProvider>
        <ConnectedNoAppointmentsFound {...props} />
    </LanguageProvider>
);
